import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { getProfile } from "../../services/mentorProfile";
import { fetchAndStoreUserProfile } from "../../services/profileService";
import SecondaryLoader from "../SecondaryLoader/SecondaryLoader";

const ProtectedRoute = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth);
  const userProfile = useSelector((state) => state.user);
  const subscriptionCheck = useSelector(
    (state) => state.auth.subscription?.isSubscribed
  );
  const isProfileComplete = useSelector(
    (state) => state.auth.isProfileComplete
  );
  const mentor = useSelector((state) => state.mentor);
  const userRole = localStorage.getItem("userType");
  const token = localStorage.getItem("authToken");

  const hasShownToast = useRef(false);

  // Fetch mentor profile when mentor logs in
  useEffect(() => {
    if (user.id && userRole === "mentor" && !mentor.profile) {
      dispatch(getProfile({ userId: user.id }));
    }
  }, [dispatch, user.id, userRole, mentor.profile]);

  // Fetch user profile when regular user logs in
  useEffect(() => {
    if (user.id && userRole === "user" && !userProfile.firstName) {
      dispatch(fetchAndStoreUserProfile(user.id));
    }
  }, [dispatch, user.id, userRole, userProfile.firstName]);

  // Profile completion is now handled by UI disabling - no toast needed
  // Users can see disabled elements and tooltips instead of redirects

  // Redirect to login if no token
  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }

  // Regular user logic
  if (userRole === "user") {
    // 1) Force subscription page until subscribed
    // if (!subscriptionCheck && location.pathname !== "/dashboard/update-subscription") {
    //   return <Navigate to="/dashboard/update-subscription" replace />;
    // }
    // 2) Profile completion is now handled by UI disabling - no redirect needed
    // Users can navigate freely but restricted content is disabled in the UI
  }

  // Mentor-specific routing logic
  if (userRole === "mentor") {
    // Show loading state while mentor profile is being fetched
    if (mentor.loading && !mentor.profile) {
      return <SecondaryLoader message="Loading your mentor dashboard..." />;
    }

    const isHelpSupportRoute = location.pathname.includes('/dashboard/help-and-support');
    if (!isProfileComplete && location.pathname !== "/dashboard/profile" && !isHelpSupportRoute) {
      return <Navigate to="/dashboard/profile" replace />;
    }
    if (!mentor.profile?.isVerified && location.pathname !== "/dashboard/profile" && !isHelpSupportRoute) {
      return <Navigate to="/dashboard/profile" replace />;
    }
    if (
      isProfileComplete &&
      mentor.profile?.isVerified &&
      !mentor.profile?.paymentAccountVerified &&
      location.pathname !== "/dashboard/account"
    ) {
      return <Navigate to="/dashboard/account" replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
